import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class FooterComponent implements OnInit {
  @Input() storeName: any;
  businessName: string | any;
  bizName: string | any;
  setupStoreLink!: string;

  constructor() {
    this.setupStoreLink = environment.SETUP_STORE_URL;
  }

  ngOnInit(): void {}
}
